import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { set, get } from '@ember/object';
import lookupValidator from 'ember-changeset-validations';
import Changeset from 'ember-changeset';
import {
  validatePresence,
  validateNumber,
} from 'ember-changeset-validations/validators';
import { isEmpty } from '@ember/utils';

const createPledgeValidation = function ({ record, existingPledges }) {
  let recordFundId = get(record, 'fundId');
  let fundIdsOfOtherPledges = existingPledges
    .filter((pledge) => get(pledge, 'fundId') !== recordFundId)
    .map((pledge) => get(pledge, 'fundId'));

  return {
    fundId(key, newValue /*oldValue, changes, content*/) {
      if (isEmpty(newValue)) {
        return "Fund can't be blank";
      }
      if (fundIdsOfOtherPledges.includes(newValue)) {
        return 'Another pledge already exists for this fund';
      }
      return true;
    },
    startDate: validatePresence({
      presence: true,
      message: "Start Date can't be blank",
    }),
    frequency: validatePresence({
      presence: true,
      message: "Frequency can't be blank",
    }),
    amount: validateNumber(),
  };
};

export default Route.extend({
  navbarSettings: service(),
  storeCache: service(),
  store: service(),

  model(params) {
    let entityDetails = this.modelFor('organization.donors.donor');
    set(this, 'navbarSettings.title', get(entityDetails, 'entity.name'));
    let record = {};
    if (params.pledgeId === 'add') {
      record = this.store.createRecord('organization/pledge', {
        entityId: get(entityDetails, 'entity.id'),
      });
    } else {
      record = get(entityDetails, 'pledges').find(
        (x) => get(x, 'id') === params.pledgeId,
      );
    }

    let validation = createPledgeValidation({
      record,
      existingPledges: get(entityDetails, 'pledges'),
    });
    let changeset = new Changeset(
      record,
      lookupValidator(validation),
      validation,
    );

    return this.storeCache.findAll('organization/fund').then((funds) => {
      return {
        entityDetails,
        funds,
        record,
        changeset,
      };
    });
  },
});
